import { Divider as DividerMui, DividerProps} from '@mui/material';

export const Divider: React.FC<DividerProps> = (props) =>
  <div className={props?.className}>
    <DividerMui light {...props} />
  </div>
